export enum bursaryTypes {
    BBDBURSARY = 'bbd',
    UKUKHULA = 'Ukukhula',
    ADHOC = 'ad hoc'
}

export enum BursaryTiers {
  LEVEL_ONE = 1,
  LEVEL_TWO = 2,
  LEVEL_THREE = 3,
  UKUKHULA = 4
}